var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDeleted)?_c('span',{staticClass:"badge-delete"},[_vm._v("Deleted")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }